import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { useAppAuth } from 'src/context/use-app-auth';
import { Role } from 'src/api/types/types';
import { conditionalRender } from 'src/utils/ui/conditional-render';
import { useTranslation } from 'src/text';
import { useWindowDimensions } from 'src/utils/ui/dimensions';
import { t3 } from 'src/themes/custom';
import {
  AddressAutocomplete,
  PlaceResult,
} from 'src/components/auto-complete/AutocompleteComponent';
import { APIProvider } from '@vis.gl/react-google-maps';
import { useReports } from '../reports-context';

const PlacesComponent: React.FC = () => {
  const { isMobile } = useWindowDimensions();
  const { reportLabels } = useTranslation();
  const { user } = useAppAuth();
  const isAddingKeywordsAllowed = user?.role === Role.admin;

  const [address, setAddress] = useState<PlaceResult>();

  const { setAddress: setReportAddress } = useReports();

  useEffect(() => {
    if (address) {
      setReportAddress(address);
    }
  }, [address]);

  return (
    <APIProvider apiKey={process.env.REACT_APP_FIREBASE_API_KEY ?? ''}>
      <Box mt={8}>
        <Typography mt={2} mb={2} variant="h3">
          {reportLabels.searchPlaces}
        </Typography>
        <>
          {conditionalRender(
            isAddingKeywordsAllowed,
            <Box width={isMobile ? '100%' : '50%'}>
              <AddressAutocomplete
                currentValue={address?.name}
                onAddressChanged={data => {
                  setAddress(data);
                }}
              />
            </Box>,
          )}
          <Typography mt={3} width={isMobile ? '100%' : '50%'} sx={t3}>
            {address
              ? `${address.name} ${address?.formatted_address}`
              : 'No place selected yet'}
          </Typography>
        </>
      </Box>
    </APIProvider>
  );
};

export { PlacesComponent };
